import { render, staticRenderFns } from "./DocumentForm.vue?vue&type=template&id=16604d9e&scoped=true&"
import script from "./DocumentForm.vue?vue&type=script&lang=js&"
export * from "./DocumentForm.vue?vue&type=script&lang=js&"
import style0 from "./DocumentForm.vue?vue&type=style&index=0&id=16604d9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16604d9e",
  null
  
)

export default component.exports